export const notificationConstants = {
    SET_LAST_IDENTIFIER: "SET_LAST_IDENTIFIER",
    CLEAR_LAST_IDENTIFIER: "CLEAR_LAST_IDENTIFIER",
    SET_PENDING_DEEP_LINK: "SET_PENDING_DEEP_LINK",
    CLEAR_PENDING_DEEP_LINK: "CLEAR_PENDING_DEEP_LINK",
}
